import type { TagsResponse } from '@/types/tag';

export type Props = PropsForPerson | PropsForItem;

interface PropsForPerson {
  contentType: 'people';
}

interface PropsForItem {
  id: string;
  contentType: 'items';
}

export function isTagResponse(arg: unknown): arg is TagsResponse {
  return (
    arg !== null &&
    typeof arg === 'object' &&
    'content_type' in arg &&
    'content_id' in arg &&
    'tags' in arg &&
    'available_tags' in arg
  );
}
